import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useShop } from "@/context/Shop";
import { api, errMsg } from "@/lib/api";

export default function AccountProfile() {
  const { customer, reloadMe } = useShop();
  const [form, setForm] = useState({ first_name: "", last_name: "", phone: "", country_code: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (customer) setForm({ first_name: customer.first_name || "", last_name: customer.last_name || "", phone: customer.phone || "", country_code: customer.country_code || "" });
  }, [customer]);
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/account/profile", { ...form, country_code: form.country_code || null });
      await reloadMe();
      toast.success("Profile updated");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="max-w-xl" data-testid="account-profile">
      <h2 className="font-display text-3xl">Profile</h2>
      <p className="text-sm text-muted-foreground mt-2">Update your personal details. Your email address can be changed through client services.</p>
      <form onSubmit={submit} className="mt-8 space-y-5 bg-white border rounded-lg p-6 lg:p-8">
        <div className="grid grid-cols-2 gap-4"><div><Label htmlFor="p-fn">First name</Label><Input id="p-fn" required value={form.first_name} onChange={upd("first_name")} data-testid="profile-firstname-input" /></div><div><Label htmlFor="p-ln">Last name</Label><Input id="p-ln" required value={form.last_name} onChange={upd("last_name")} data-testid="profile-lastname-input" /></div></div>
        <div><Label>Email</Label><Input value={customer?.email || ""} disabled data-testid="profile-email-input" /></div>
        <div className="grid grid-cols-2 gap-4"><div><Label htmlFor="p-ph">Phone</Label><Input id="p-ph" value={form.phone} onChange={upd("phone")} data-testid="profile-phone-input" /></div><div><Label htmlFor="p-cc">Country (ISO)</Label><Input id="p-cc" maxLength={2} value={form.country_code} onChange={(e) => setForm({ ...form, country_code: e.target.value.toUpperCase() })} data-testid="profile-country-input" /></div></div>
        <button type="submit" disabled={busy} className="btn-ink" data-testid="profile-save-button">{busy ? "Saving…" : "Save changes"}</button>
      </form>
    </div>
  );
}
